// extracted by mini-css-extract-plugin
export default {"header":"LoginFrom_header__RFDxq","input":"LoginFrom_input__Amf0u","form":"LoginFrom_form__ciHl-"};